export default "__VITE_ASSET__DGMTpmK$__"